module.exports = __webpack_public_path__ + "static/media/3.ee02dc6c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/維也納奶油抹醬/3.JPG
// module id = 934
// module chunks = 0